import L from "leaflet";
import type { BBox } from "./types";

/** Default view: Budapest, used until the user moves the map. */
const DEFAULT_CENTER: L.LatLngTuple = [47.4979, 19.0402];
const DEFAULT_ZOOM = 13;

/** Mirrors the API's bbox cap (bboxMaxWidthDeg / bboxMaxHeightDeg). */
const BBOX_MAX_WIDTH_DEG = 8;
const BBOX_MAX_HEIGHT_DEG = 5;

export function createMap(containerId: string): L.Map {
  const map = L.map(containerId, {
    center: DEFAULT_CENTER,
    zoom: DEFAULT_ZOOM,
    zoomControl: false,
    minZoom: 5,
  });

  L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
    maxZoom: 19,
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> közreműködők',
  }).addTo(map);

  L.control.zoom({ position: "topright" }).addTo(map);
  return map;
}

/** Current viewport as an API bbox, clamped to valid lon/lat ranges. */
export function viewBBox(map: L.Map): BBox {
  const b = map.getBounds();
  return {
    minLon: Math.max(-180, b.getWest()),
    minLat: Math.max(-90, b.getSouth()),
    maxLon: Math.min(180, b.getEast()),
    maxLat: Math.min(90, b.getNorth()),
  };
}

/** True when the viewport exceeds what GET /places accepts. */
export function bboxTooLarge(b: BBox): boolean {
  return b.maxLon - b.minLon > BBOX_MAX_WIDTH_DEG || b.maxLat - b.minLat > BBOX_MAX_HEIGHT_DEG;
}
